import { useI18N } from "@sundae/react-hooks";
import { FadeInBasic, Text } from "@sundae/ui-toolkit";
import { FC } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import TasteTestSocials from "../TasteTestSocials";
import TasteTestTeamMembers from "../TasteTestTeamMembers";

const TasteTestProjectTeam: FC = () => {
  const { t } = useI18N("taste-test");
  const {
    state: { tasteTest, tasteTestPersonalization },
  } = useTasteTestContext();
  return (
    <FadeInBasic className="flex flex-col gap-4">
      <div className="flex flex-col gap-6">
        <div className="flex w-full items-start justify-between gap-4">
          <div className="grid w-full gap-2">
            <div className="flex items-start gap-4">
              <Text className="w-2/5 xl:w-1/5" size="sm" tag="span" variant="muted">
                {t("detail.projectDetails.team.company")}
              </Text>
              <Text className="flex-1" size="sm" tag="span">
                {tasteTest?.projectDetails.team.company}
              </Text>
            </div>

            <div className="flex items-start gap-4">
              <Text className="w-2/5 xl:w-1/5" size="sm" tag="span" variant="muted">
                {t("detail.projectDetails.team.members")}
              </Text>

              <Text size="sm" tag="div" className="flex-1">
                <TasteTestTeamMembers
                  tasteTestPersonalization={tasteTestPersonalization}
                  teamMembers={tasteTest?.projectDetails?.team?.members}
                />
              </Text>
            </div>

            {tasteTest && tasteTest.projectDetails.team.other?.length > 0 && (
              <div className="flex items-start gap-4">
                <Text className="w-2/5 xl:w-1/5" size="sm" tag="span" variant="muted">
                  {t("detail.projectDetails.team.other")}
                </Text>
                <Text className="flex-1" size="sm" tag="span">
                  {tasteTest.projectDetails.team.other.map((other) => other).join(", ")}
                </Text>
              </div>
            )}
          </div>
        </div>

        {tasteTest && tasteTest?.projectDetails?.team?.socials?.length > 0 && (
          <div className="grid gap-4">
            <Text tag="p" weight="medium">
              {t("detail.socials", { context: "team" })}
            </Text>
            <div className="flex items-center gap-2">
              <TasteTestSocials socials={tasteTest.projectDetails.team.socials} />
            </div>
          </div>
        )}
      </div>
    </FadeInBasic>
  );
};

export default TasteTestProjectTeam;
